module.exports = __webpack_public_path__ + "img/map.ce1c9166.svg";